import { AsYouType, CountryCode, getCountryCallingCode } from 'libphonenumber-js';
import { normalizePhoneDigits } from './digits.util';
import { parseNationalPhoneNumber } from './phone-parse.util';
import { IPhoneFormatResult } from './types';

function toNationalDisplayWithoutTrunk(
  country: CountryCode,
  formattedInternational: string
): string {
  const callingCode = getCountryCallingCode(country);
  let national = formattedInternational;

  if (national.startsWith('+')) {
    national = national.replace(new RegExp(`^\\+${callingCode}\\s*`), '');
  }

  if (national.startsWith('+')) {
    return '';
  }

  return national.replace(/^0+/, '').trimStart();
}

export function formatPhoneNationalInput(
  country: CountryCode,
  rawDigits: string
): IPhoneFormatResult {
  const digits = normalizePhoneDigits(rawDigits);

  if (!digits) {
    return { formatted: '', digits: '' };
  }

  const callingCode = getCountryCallingCode(country);
  const formatter = new AsYouType(country);
  const formattedInternational = formatter.input(`+${callingCode}${digits}`);
  const parsed = formatter.getNumber() ?? parseNationalPhoneNumber(country, digits);

  if (parsed?.isValid()) {
    return {
      formatted: parsed.formatNational().replace(/^0+/, ''),
      digits,
    };
  }

  const formatted = toNationalDisplayWithoutTrunk(country, formattedInternational);

  return {
    formatted: formatted || digits,
    digits,
  };
}

export function getCursorPositionForFormattedPhone(
  formatted: string,
  digitsBeforeCursor: number
): number {
  if (digitsBeforeCursor <= 0) {
    return 0;
  }

  let digitCount = 0;

  for (let index = 0; index < formatted.length; index++) {
    if (/\d/.test(formatted[index])) {
      digitCount++;

      if (digitCount >= digitsBeforeCursor) {
        return index + 1;
      }
    }
  }

  return formatted.length;
}
